import Swiper from "swiper";

export default function LibrarySlider(container) {
    const nextButtonElement = container.querySelector(".js-library-slider-button-next");
    const previousButtonElement = container.querySelector(".js-library-slider-button-prev");
    const paginationElement = container.querySelector(".js-library-slider-pagination");

    new Swiper(container, {
        direction: "vertical",
        loop: true,
        spaceBetween: 30,
        speed: 600,
        slidesPerView: 1,
        slideClass: "js-library-slider-slide",
        wrapperClass: "js-library-slider-wrapper",
        containerModifierClass: "library__slider-",
        navigation: {
            nextEl: nextButtonElement,
            prevEl: previousButtonElement,
        },
        pagination: {
            el: paginationElement,
            type: "fraction",
        }
    });
}